"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPageContent = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PageContentMixin = require("../../mixins/components/PageContentMixin");
var _doNotForwardTransientProp = require("../../util/doNotForwardTransientProp");
var StyledPageContent = /*#__PURE__*/(0, _styledComponents.default)('div').withConfig({
  shouldForwardProp: (0, _doNotForwardTransientProp.doNotForwardTransientProp)(['display'])
}).withConfig({
  displayName: "StyledPageContent",
  componentId: "c11n-8-107-0__sc-opuuk8-0"
})(["", ""], _PageContentMixin.PageContentMixin);
exports.StyledPageContent = StyledPageContent;